var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2H8.25V8.75H1.5V2ZM3 3.5V7.25H6.75V3.5H3ZM13.125 3.5C12.6277 3.5 12.1508 3.69754 11.7992 4.04918C11.4475 4.40081 11.25 4.87772 11.25 5.375C11.25 5.87228 11.4475 6.3492 11.7992 6.70083C12.1508 7.05246 12.6277 7.25 13.125 7.25C13.6223 7.25 14.0992 7.05246 14.4508 6.70083C14.8025 6.3492 15 5.87228 15 5.375C15 4.87772 14.8025 4.40081 14.4508 4.04918C14.0992 3.69754 13.6223 3.5 13.125 3.5ZM9.75 5.375C9.75 4.93179 9.8373 4.49292 10.0069 4.08344C10.1765 3.67397 10.4251 3.30191 10.7385 2.98851C11.0519 2.67512 11.424 2.42652 11.8334 2.25691C12.2429 2.0873 12.6818 2 13.125 2C13.5682 2 14.0071 2.0873 14.4166 2.25691C14.826 2.42652 15.1981 2.67512 15.5115 2.98851C15.8249 3.30191 16.0735 3.67397 16.2431 4.08344C16.4127 4.49292 16.5 4.93179 16.5 5.375C16.5 6.27011 16.1444 7.12855 15.5115 7.76149C14.8786 8.39442 14.0201 8.75 13.125 8.75C12.2299 8.75 11.3715 8.39442 10.7385 7.76149C10.1056 7.12855 9.75 6.27011 9.75 5.375ZM1.5 10.25H8.25V17H1.5V10.25ZM3 11.75V15.5H6.75V11.75H3ZM9.75 10.25H16.5V17H9.75V10.25ZM11.25 11.75V15.5H15V11.75H11.25Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.1a0df72a3bcc789cb044175e7e90eefe.svg";
export { ForwardRef as ReactComponent };